module.exports = __webpack_public_path__ + "assets/611e65c62f455ac5c149a45698c4634a.png";